<!-- 组件说明 -->
<template>
  <!-- 主页main模块 -->
  <div>
    <div class="container">
      <div class="con">
        <div class="main">
          <div class="focus">
            <el-carousel
              :autoplay="true"
              arrow="always"
              ref="welcome"
              height="450px"
            >
              <el-carousel-item
                v-for="(item, index) in itemdata"
                :key="index"
                class="c-pointer"
              >
                <img v-lazy="item.image" alt="" @click="indexgoto(item)" />
              </el-carousel-item>
              <div class="preBtn"></div>
              <div class="nextBtn"></div>
            </el-carousel>
          </div>
          <!-- 未登录样式 -->
          <div class="login" v-if="!hasLogin">
            <div class="avatar">
              <img :src="require('@/assets/images/defaultgraph.png')" alt="" />
            </div>
            <span>欢迎登录~</span>
            <router-link
              tag="a"
              :to="{ path: '/login', query: { type: 1 } }"
              class="loginBtn"
              >登录</router-link
            >
            <router-link
              tag="a"
              :to="{ path: '/login', query: { type: 2 } }"
              class="registerBtn"
              >注册</router-link
            >
          </div>
          <!-- 登录后样式 -->
          <div class="user" v-if="hasLogin">
            <router-link
              tag="div"
              to="/person/center"
              class="avatar user-avatar"
            >
              <img v-lazy="userInfo.avatar" alt="" />
            </router-link>
            <span class="nickname">{{ userInfo.nickname }}</span>
            <!-- <div class="user-serve c-pointer">
              <router-link tag="div" to="/getcoupon" class="serve-item">
                <div class="serve-img">
                  <img
                    :src="require('@/assets/images/icon_ccoupons.png')"
                    alt=""
                  />
                </div>
                <span>领券中心</span>
              </router-link>
              <router-link tag="div" to="/person/coupon" class="serve-item">
                <div class="serve-img">
                  <img
                    :src="require('@/assets/images/icon_cmycoupons.png')"
                    alt=""
                  />
                </div>
                <span>我的优惠券</span>
              </router-link>
              <router-link tag="div" to="/person/myorder" class="serve-item">
                <div class="serve-img">
                  <img
                    :src="require('@/assets/images/icon_cmyorder.png')"
                    alt=""
                  />
                </div>
                <span>我的订单</span>
              </router-link>
              <router-link tag="div" to="/person/service" class="serve-item">
                <div class="serve-img">
                  <img
                    :src="require('@/assets/images/icon_ccenter.png')"
                    alt=""
                  />
                </div>
                <span>售后中心</span>
              </router-link>
            </div> -->
            <a href="#" class="loginoutBtn" @click="LOGINOUT">安全退出</a>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  props: ["itemdata"],
  components: {},
  data() {
    return {
      isLogin: false,
      index: 1,
      timer: "",
    };
  },
  computed: {
    ...mapState(["hasLogin", "userInfo"]),
    ...mapState("sessionData", ["notice_cid_3"]),
    newArray() {
      let index = 0
      let arr = []
      while (index < this.notice_cid_3.length) {
         arr.push(this.notice_cid_3.slice(index, (index += 3)));
      }
      return arr
    }
  },
  mounted() {},
  methods: {
    ...mapMutations(["LOGINOUT"]),
    toDetail(item) {
      //console.log(item.id);
      this.$router.push({ name: "helpcenter", query: { id: item.id } });
    },
    indexgoto(item) {
      this.$emit("indexgoto", item);
    },
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.container {
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}
.preBtn {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  background: url("../../../../assets/images/banner_left.png") no-repeat;
  background-size: 100%;
  width: 46px;
  height: 54px;
  z-index: 100;
}
.nextBtn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: url("../../../../assets/images/banner_right.png") no-repeat;
  background-size: 100%;
  width: 46px;
  height: 54px;
  z-index: 100;
}
>>> .el-carousel__container {
  // height: 450px !important;
}
>>> .el-carousel__button {
  width: 10px !important;
  height: 10px !important;
  border-radius: 50% !important;
  background-color: #000000 !important;
  opacity: 0.6 !important;
}
>>> .el-carousel__indicator.is-active button {
  background-color: #ffffff !important;
  // opacity: 1!important;
}
>>> .el-carousel__arrow--left {
  opacity: 0 !important;
  z-index: 200;
  width: 46px !important;
  height: 54px !important;
  border-radius: 0;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  left: 0;
}
>>> .el-carousel--horizontal {
  overflow: hidden;
}
>>> .el-carousel__arrow--right {
  opacity: 0 !important;
  z-index: 200;
  width: 46px !important;
  height: 54px !important;
  border-radius: 0;
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  right: 0;
}
// main模块
.main {
  position: relative;
  display: flex;
  margin-left: 194px;
  .focus {
    width: 820px;
    height: 450px;
    overflow-y: hidden;
    img {
      @include size(100%, 100%);
    }
  }
  .login {
    height: 95%;
    width: 176px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    box-shadow: 0 0 12px 1px #f0f0f0;
    position: absolute;
    right: 0;
    margin: 14px 0;
    .avatar {
      height: 72px;
      width: 72px;
      margin: 82px 0 22px 0;
      border-radius: 36px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    span {
      color: #808080;
      font-size: 14px;
    }
    .loginBtn {
      display: block;
      margin: 36px 0 14px 0;
      color: #ffffff;
      width: 128px;
      height: 32px;
      line-height: 32px;
      background-color: #fa4b4b;
      text-align: center;
      font-size: 14px;
    }
    .registerBtn {
      display: block;
      border: 1px solid #fa4b4b;
      border-radius: 2px;
      color: #fa4b4b;
      text-align: center;
      width: 128px;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
  }
}

.user {
  position: absolute;
  right: 0;
  margin: 14px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 176px;
  padding: 0 15px;
  background-color: #ffffff;
  box-shadow: 0 0 18px 1px #f0f0f0;

  .user-avatar {
    position: relative;
    margin-top: 34px;
    height: 72px;
    width: 72px;
    border-radius: 36px;
    border: 1px solid #f2f2f2;
    overflow: hidden;
    img {
      @include size(100%, 100%);
    }
    &:hover {
      &::after {
        opacity: 0.45;
      }
    }
    &::after {
      position: absolute;
      display: block;
      content: "更换头像";
      width: 100%;
      height: 100%;
      background-color: black;
      opacity: 0;
      left: 0;
      bottom: 0;
      color: #ffffff;
      text-align: center;
      line-height: 72px;
      font-size: 14px;
      cursor: pointer;
    }
  }
  > span {
    text-align: center;
    margin: 18px 0 20px 0;
    font-size: 14px;
    color: #808080;
    width: 100%;
  }
  .user-serve {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    .serve-item {
      width: 50%;
      align-items: center;
      margin-bottom: 20px;
      @include flex-d-c;
      .serve-img {
        margin-bottom: 10px;
      }
      span {
        font-size: 12px;
        color: #666666;
      }
    }
  }
  .loginoutBtn {
    display: block;
    width: 128px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    color: #808080;
    font-size: 14px;
    border: 1px solid #f2f2ff;
    margin-bottom: 20px;
  }
}
.notice {
  display: flex;
  align-items: center;
  margin-top: 20px;
  height: 108px;
  background-color: #ffffff;
  .notice-img {
    margin: 0 44px 0 52px;
  }
  ul li {
    // list-style: disc;
    color: #808080;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;
  }
}
.noticeList {
  height: 60px;
  overflow: hidden;
}
.noticeCarousel {
  width: 900px;
}
// >>>.el-carousel__container{
//
// }
</style>



// WEBPACK FOOTER //
// src/pages/main/home/components/home-main.vue